import React from "react";
import { LoadioArtistPreviewAlbumListTemplate } from "themes/administration/loadio/components";

class LoadioArtistPreviewAlbumList extends React.Component {
    render() {
        return <LoadioArtistPreviewAlbumListTemplate {...this.props} />;
    }
}

export default LoadioArtistPreviewAlbumList;
